import { knowledgeBaseItemsQuery } from "@/views/settings/base-knowledge/index/gql/queries";

export const KNOWLEDGE_BASE_ITEM_ARTICLE = "Article";
export const KNOWLEDGE_BASE_ITEM_SECTION = "KnowledgeBaseSection";

const KNOWLEDGE_BASE_ITEM_TYPE = {
  Article: "article",
  KnowledgeBaseSection: "section",
};

async function getApolloClient() {
  const { default: apolloClient } = await import("@/plugins/apollo-vue");

  return apolloClient;
}

export function isKnowledgeBaseSection(item) {
  return item?.__typename === KNOWLEDGE_BASE_ITEM_SECTION || item?.type === "section";
}

export function mapKnowledgeBaseItems(items = []) {
  return [...items]
    .sort((first, second) => (first.position ?? 0) - (second.position ?? 0))
    .map((item) => {
      const isSection = item.__typename === KNOWLEDGE_BASE_ITEM_SECTION;

      return {
        id: item.id,
        name: item.name,
        parentId: item.parentId ?? null,
        position: item.position,
        visibleForDealers: item.visibleForDealers,
        __typename: item.__typename,
        type: isSection ? "section" : item.type,
        content: item.content,
      };
    });
}

export function toKnowledgeBaseItemRefs(items = []) {
  return items.map((item) => ({
    id: item.id,
    type: isKnowledgeBaseSection(item)
      ? KNOWLEDGE_BASE_ITEM_TYPE.KnowledgeBaseSection
      : KNOWLEDGE_BASE_ITEM_TYPE.Article,
  }));
}

function buildKnowledgeBaseItemsVariables(parentIdOrFilters) {
  if (parentIdOrFilters && typeof parentIdOrFilters === "object") {
    const { parentId, audience, nameContains } = parentIdOrFilters;
    const variables = {};

    if (parentId) variables.parentId = parentId;
    if (audience) variables.audience = audience;
    if (nameContains) variables.nameContains = nameContains;

    return variables;
  }

  return { parentId: parentIdOrFilters };
}

async function queryKnowledgeBaseItems(variables) {
  const apolloClient = await getApolloClient();
  const response = await apolloClient.query({
    query: knowledgeBaseItemsQuery,
    fetchPolicy: "no-cache",
    ...(Object.keys(variables).length ? { variables } : {}),
  });

  return mapKnowledgeBaseItems(response?.data?.knowledgeBaseItems || []);
}

export async function fetchKnowledgeBaseItems(parentIdOrFilters = null) {
  return queryKnowledgeBaseItems(buildKnowledgeBaseItemsVariables(parentIdOrFilters));
}
